import React, { ReactElement, useEffect, useState } from 'react'
import { Flex, Image, PriceText, Text } from '@mindfulchefuk/design-system'
import { AnimatePresence, motion, Variants } from 'motion/react'
import {
  Recipe,
  RecipeWithQuantity,
} from '@mindfulchefuk/features/Recipes/interfaces'
import { css } from 'styled-system/css'

const variants: Variants = {
  show: { opacity: 1, y: 0, transition: { when: 'beforeChildren' } },
  hide: { opacity: 0, y: 100 },
  exit: {
    opacity: 0,
    transition: { when: 'afterChildren' },
  },
}

export const NewestCartItem = ({
  item,
}: {
  item: Recipe | RecipeWithQuantity | undefined
}): ReactElement => {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    let timeout: NodeJS.Timeout
    clearTimeout(timeout)

    if (item) {
      setIsVisible(true)
      timeout = setTimeout(() => setIsVisible(false), 2000)
    } else {
      setIsVisible(false)
    }

    return () => clearTimeout(timeout)
  }, [item])

  if (!item) {
    return null
  }

  return (
    <AnimatePresence mode="wait">
      {isVisible && item && (
        <motion.div
          variants={variants}
          initial="hide"
          animate="show"
          exit="exit"
          layout
          data-testid="newest-cart-item"
          className={css({
            display: 'none',
            sm: { display: 'block' },
            position: 'absolute',
            color: 'aubergine-800',
            backgroundColor: 'white',
            right: 10,
            top: -6,
            boxShadow: 'standard',
            width: 96,
            zIndex: 'notification',
          })}
        >
          <Flex width={384}>
            <Image
              className={css({
                height: '100%',
                objectFit: 'cover',
                width: '96px',
                minHeight: '76px',
              })}
              src={item.imageUrl}
              alt=""
              width={120}
              height={95}
            />
            <Flex justify="space-between" flexGrow={1} p={14}>
              <Text variant="body-sm-500">{item.title}</Text>
              <PriceText
                variant="body-sm"
                flexShrink={1}
                ml={32}
                price={item.price}
              />
            </Flex>
          </Flex>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
